/* tslint:disable */

/* eslint-disable */

/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import type { AxiosInstance, AxiosPromise, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";

// @ts-ignore
import {
  BASE_PATH,
  BaseAPI,
  COLLECTION_FORMATS,
  RequestArgs,
  RequiredError,
  operationServerMap,
} from "../base";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  createRequestFunction,
  serializeDataIfNeeded,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  toPathString,
} from "../common";
import type { Configuration } from "../configuration";
// @ts-ignore
import { HandsLimit } from "../models";
// @ts-ignore
import { SetHandsLimitRequest } from "../models";

/**
 * HandsLimitControllerApi - axios parameter creator
 * @export
 */
export const HandsLimitControllerApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary DELETE /api/v2/hands-limit/:domain/:partner_id
     * @param {string} domain
     * @param {string} partnerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteHandsLimit: async (
      domain: string,
      partnerId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'domain' is not null or undefined
      assertParamExists("deleteHandsLimit", "domain", domain);
      // verify required parameter 'partnerId' is not null or undefined
      assertParamExists("deleteHandsLimit", "partnerId", partnerId);
      const localVarPath = `/api/v2/hands-limit/{domain}/{partner_id}`
        .replace(`{${"domain"}}`, encodeURIComponent(String(domain)))
        .replace(`{${"partner_id"}}`, encodeURIComponent(String(partnerId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "DELETE", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary GET /api/v2/hands-limit/:domain/:partner_id
     * @param {string} domain
     * @param {string} partnerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHandsLimit: async (
      domain: string,
      partnerId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'domain' is not null or undefined
      assertParamExists("getHandsLimit", "domain", domain);
      // verify required parameter 'partnerId' is not null or undefined
      assertParamExists("getHandsLimit", "partnerId", partnerId);
      const localVarPath = `/api/v2/hands-limit/{domain}/{partner_id}`
        .replace(`{${"domain"}}`, encodeURIComponent(String(domain)))
        .replace(`{${"partner_id"}}`, encodeURIComponent(String(partnerId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary PUT /api/v2/hands-limit/:domain/:partner_id
     * @param {string} domain
     * @param {string} partnerId
     * @param {SetHandsLimitRequest} setHandsLimitRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setHandsLimit: async (
      domain: string,
      partnerId: string,
      setHandsLimitRequest: SetHandsLimitRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'domain' is not null or undefined
      assertParamExists("setHandsLimit", "domain", domain);
      // verify required parameter 'partnerId' is not null or undefined
      assertParamExists("setHandsLimit", "partnerId", partnerId);
      // verify required parameter 'setHandsLimitRequest' is not null or undefined
      assertParamExists("setHandsLimit", "setHandsLimitRequest", setHandsLimitRequest);
      const localVarPath = `/api/v2/hands-limit/{domain}/{partner_id}`
        .replace(`{${"domain"}}`, encodeURIComponent(String(domain)))
        .replace(`{${"partner_id"}}`, encodeURIComponent(String(partnerId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        setHandsLimitRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * HandsLimitControllerApi - functional programming interface
 * @export
 */
export const HandsLimitControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = HandsLimitControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary DELETE /api/v2/hands-limit/:domain/:partner_id
     * @param {string} domain
     * @param {string} partnerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteHandsLimit(
      domain: string,
      partnerId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteHandsLimit(
        domain,
        partnerId,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["HandsLimitControllerApi.deleteHandsLimit"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @summary GET /api/v2/hands-limit/:domain/:partner_id
     * @param {string} domain
     * @param {string} partnerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHandsLimit(
      domain: string,
      partnerId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HandsLimit>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getHandsLimit(
        domain,
        partnerId,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["HandsLimitControllerApi.getHandsLimit"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @summary PUT /api/v2/hands-limit/:domain/:partner_id
     * @param {string} domain
     * @param {string} partnerId
     * @param {SetHandsLimitRequest} setHandsLimitRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async setHandsLimit(
      domain: string,
      partnerId: string,
      setHandsLimitRequest: SetHandsLimitRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.setHandsLimit(
        domain,
        partnerId,
        setHandsLimitRequest,
        options
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap["HandsLimitControllerApi.setHandsLimit"]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * HandsLimitControllerApi - factory interface
 * @export
 */
export const HandsLimitControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = HandsLimitControllerApiFp(configuration);
  return {
    /**
     *
     * @summary DELETE /api/v2/hands-limit/:domain/:partner_id
     * @param {string} domain
     * @param {string} partnerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteHandsLimit(domain: string, partnerId: string, options?: any): AxiosPromise<void> {
      return localVarFp
        .deleteHandsLimit(domain, partnerId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary GET /api/v2/hands-limit/:domain/:partner_id
     * @param {string} domain
     * @param {string} partnerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHandsLimit(domain: string, partnerId: string, options?: any): AxiosPromise<HandsLimit> {
      return localVarFp
        .getHandsLimit(domain, partnerId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary PUT /api/v2/hands-limit/:domain/:partner_id
     * @param {string} domain
     * @param {string} partnerId
     * @param {SetHandsLimitRequest} setHandsLimitRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    setHandsLimit(
      domain: string,
      partnerId: string,
      setHandsLimitRequest: SetHandsLimitRequest,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .setHandsLimit(domain, partnerId, setHandsLimitRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * HandsLimitControllerApi - object-oriented interface
 * @export
 * @class HandsLimitControllerApi
 * @extends {BaseAPI}
 */
export class HandsLimitControllerApi extends BaseAPI {
  /**
   *
   * @summary DELETE /api/v2/hands-limit/:domain/:partner_id
   * @param {string} domain
   * @param {string} partnerId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HandsLimitControllerApi
   */
  public deleteHandsLimit(domain: string, partnerId: string, options?: RawAxiosRequestConfig) {
    return HandsLimitControllerApiFp(this.configuration)
      .deleteHandsLimit(domain, partnerId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary GET /api/v2/hands-limit/:domain/:partner_id
   * @param {string} domain
   * @param {string} partnerId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HandsLimitControllerApi
   */
  public getHandsLimit(domain: string, partnerId: string, options?: RawAxiosRequestConfig) {
    return HandsLimitControllerApiFp(this.configuration)
      .getHandsLimit(domain, partnerId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary PUT /api/v2/hands-limit/:domain/:partner_id
   * @param {string} domain
   * @param {string} partnerId
   * @param {SetHandsLimitRequest} setHandsLimitRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HandsLimitControllerApi
   */
  public setHandsLimit(
    domain: string,
    partnerId: string,
    setHandsLimitRequest: SetHandsLimitRequest,
    options?: RawAxiosRequestConfig
  ) {
    return HandsLimitControllerApiFp(this.configuration)
      .setHandsLimit(domain, partnerId, setHandsLimitRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
